module.exports = __webpack_public_path__ + "img/bg-mesin.de49ee0b.jpg";